import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentPaginationPage: 1,
  itemsPerPage: 10,
  totalPages: 1,
  totalItems: 0,
};

const paginationSlice = createSlice({
  name: 'pagination',
  initialState,
  reducers: {
    setPaginationPage: (state, action) => {
      state.currentPaginationPage = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setTotalItems: (state, action) => {
      state.totalItems = action.payload;
      // Автоматически пересчитываем totalPages
      state.totalPages = Math.ceil(action.payload / state.itemsPerPage) || 1;
    },
    resetPagination: (state) => {
      state.currentPaginationPage = 1;
    },
    updatePaginationFromItems: (state, action) => {
      const totalItems = action.payload;
      state.totalItems = totalItems;
      state.totalPages = Math.ceil(totalItems / state.itemsPerPage) || 1;

      // Если текущая страница больше доступного количества страниц, сбрасываем на 1
      if (state.currentPaginationPage > state.totalPages) {
        //   `Pagination: Current page ${state.currentPaginationPage} is greater than total pages ${state.totalPages}, resetting to page 1`,
        // );
        state.currentPaginationPage = 1;
      }
    },
  },
});

export const {
  setPaginationPage,
  setItemsPerPage,
  setTotalPages,
  setTotalItems,
  resetPagination,
  updatePaginationFromItems,
} = paginationSlice.actions;

export default paginationSlice.reducer;
